<div class="contact-us">
    <app-hero-section [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath" [description]="description"
        [joinChat]="joinChat">
    </app-hero-section>
    <div class="contact-us__content">
        <div class="contact-us__container">
            <div class="contact-us__holder" *ngIf="currentLanguage == 'en'">
                <div style="position:relative; width:100%; height:0; padding-bottom:800px;">
                    <iframe 
                        src="https://solidrange.clickup.com/forms/9018770919/f/8crz1f7-26578/KQ1S26VUFJHOTAAQED"
                        style="position:absolute; top:0; left:0; width:100%; height:100%; border:none;"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
            <div class="contact-us__holder" *ngIf="currentLanguage == 'ar'">
                <div style="position:relative; width:100%; height:0; padding-bottom:800px;">
                    <iframe 
                        src="https://solidrange.clickup.com/forms/9018770919/f/8crz1f7-26598/RX47EGCDRFTP3MR3KP"
                        style="position:absolute; top:0; left:0; width:100%; height:100%; border:none;"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>